import { useNavigate, useLocation,useSearchParams } from "react-router-dom";
import Navbar from "./Navbar";
import FooterSection from "./footersection";
import { FcGoogle } from "react-icons/fc";
import { SiApple } from "react-icons/si";
import "./app-wide.css";
import "./footersection.css";
import "./loginpage.css";
import { GoogleAuthProvider, OAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../firebase";
import { useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import axios from 'axios';
import { fetchItems,createItem } from "../api/networking";
import PrivacyPolicyContent from "./privacy_policy_page_content";
import TermsOfServiceContent from "./term_of_service_content";




const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromSignup = location.state?.fromSignup;
  const [searchParams] = useSearchParams();
  const fromSignup2 = searchParams.get('fromSignup') === 'true';
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  const [account_type, setaccountype] = useState();
  const [error, setError] = useState("");



  // Terms/Privacy handling
  const [termsModal, setTermsModal] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);
  const [termsClicked, setTermsClicked] = useState(false);
  const [privacyClicked, setPrivacyClicked] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  // Open Under construction modal
  const [showModal, setShowModal] = useState(false);

  const [agreed, setAgreed] = useState(false);


  // Track if each file was opened
  const [termsOpened, setTermsOpened] = useState(false);
  const [privacyOpened, setPrivacyOpened] = useState(false);

  const handleOpenTerms = () => {
    setTermsModal(true);
    setTermsOpened(true);
    if (privacyOpened) setAgreed(true); // auto-check once both are opened
  };

  const handleOpenPrivacy = () => {
    setPrivacyModal(true);
    setPrivacyOpened(true);
    if (termsOpened) setAgreed(true); // auto-check once both are opened
  };





  useEffect(() => {
    if (termsClicked && privacyClicked) {
      setCheckboxChecked(true);
    }
  }, [termsClicked, privacyClicked]);



  useEffect(()=>{
    console.log("Current Page", fromSignup2)
  }
)


  const  handleLogin = async(e) => {
    e.preventDefault();
    // TODO: Replace with real auth logic
    if (password.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    try{
      const response = await createItem('/login',{email, password});


      if(response[0] == 200){

        console.log(response[1]['account_type'])
        if (response[1]['account_type']== "Admin"){
          navigate("/dashboard", { state: { isAdmin: true , initials: response[1]['account_initial'] } });
        }else{
          navigate("/dashboard", { state: { isAdmin: false , initials: response[1]['account_initial'], email:response[1]['email'] }});
        }
        //navigate("/dashboard");
      }

      
    }catch(e){
      console.log("Error: ",e.status)
      console.log("Error: ",e.code)
      setError("Invalid email or password.");
    }
    /*axios.get('http://127.0.0.1:8000/items')
    .then(response => {
      console.log(response.data);
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      //setError('Could not connect to API');
    });*/
    //navigate("/dashboard");
  };

  const  handleCreateAccount = async(e) => {
    e.preventDefault();
    // TODO: Replace with real auth logic
    if (password.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    try{
      const response = await createItem('/createAccount',{ email, firstname,lastname, password, account_type, term_privacy_check: agreed });


      if(response[0] == 200){

        navigate("/dashboard", { state: { isAdmin: false, email:email, initials: (firstname[0]+lastname[0]).toUpperCase()} });
        //navigate("/dashboard");
      }

      
    }catch(e){
      console.log("Error: ",e.status)
      console.log("Error: ",e.code)
      setError("Invalid email or password.");
    }
    /*axios.get('http://127.0.0.1:8000/items')
    .then(response => {
      console.log(response.data);
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      //setError('Could not connect to API');
    });*/
    //navigate("/dashboard");
  };

    const handleGoogleLogin = async () => {
      const provider = new GoogleAuthProvider();
      try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;
        console.log("Google Sign-In User:", user);
        // You can now access user.email, user.displayName, etc.
      } catch (error) {
        console.error("Google Sign-In Error:", error);
      }
    };

    const handleAppleLogin = async () => {
      const provider = new OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');
      
      try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;
        console.log("Apple Sign-In User:", user);
        navigate("/dashboard");
      } catch (error) {
        console.error("Apple Sign-In Error:", error);
      }
    };

    const handleLoginNone = (e) => {
      e.preventDefault();
      setShowModal(true);
    };
    
    const handleGoogleLoginNone = async () => {
      setShowModal(true);
    };
    
    const handleAppleLoginNone = async () => {
      setShowModal(true);
    };

    const passwordChange = (e)=>{
      setPassword(e.target.value)
      setError("")
    }

    const handleAccountTypeChange = (e) => {
      setaccountype(e.target.value); // will be Hobbyist, Professional, or Personal
    };

    


  return (
    <div className="login-whole-container">
      <div className="login-whole-inner-container">
        <Navbar hideNav={true} isLogin={fromSignup2?false:true} isSignup={fromSignup2}/>
          <div className="login-section login-inner-section-grid">
              <div className="">
                  
              {fromSignup2?
                <form onSubmit={handleCreateAccount} className="login-form-signup">
                    <h2 className="text-xl mb-4">Get Started</h2>
                    <div className="login-sub-title">
                      <p>Welcome to Stock Archives - Let’s create your account</p>
                    </div>
                    <label  className="login-form-label" for="fname">Email: </label><br/>

                    <input onChange={(e) => setEmail(e.target.value)} 
                    type="email" className="login-form-input" required /><br/>

                    <label className="login-form-label" for="fname">First Name: </label><br/>

                    <input onChange={(e) => setFirstname(e.target.value)} 
                    type="text" className="login-form-input" required /><br/>

                    <label className="login-form-label" for="fname">Last Name: </label><br/>

                    <input onChange={(e) => setLastname(e.target.value)}  
                    type="text" className="login-form-input" required /><br/>

                    <label className="login-form-label" for="fpassword">Password: </label><br/>

                    <input onChange={(e) => setPassword(e.target.value)} 
                      type="password" className="login-form-input" required /><br/>

                    {error == ""?<label></label>:<label className="error">{error}</label>} 

                    <br/>

                    <label className="login-form-label" for="fpassword">Account Type: <FaInfoCircle /> </label><br/>

                    <label>
                      <input
                        name="accountType"
                        value="Hobbyist"
                        checked={account_type === "Hobbyist"}
                      onChange={handleAccountTypeChange} type="radio"/>
                      Hobbyist
                    </label>

                    <label>
                      <input
                        name="accountType"
                        value="Professional"
                        checked={account_type === "Professional"}
                      
                      onChange={handleAccountTypeChange} type="radio"/>
                      Professional
                    </label>

                    <label>
                      <input 
                        name="accountType"
                        value="Personal"
                        checked={account_type === "Personal"}
                      onChange={handleAccountTypeChange} type="radio"/>
                      Personal
                    </label><br/>
                     {/* ✅ Terms + Privacy Section */}
                    <div className="terms-privacy-container">
                      <input
                        type="checkbox"
                        checked={agreed}
                        onChange={() => setAgreed(!agreed)}
                      />
                      <span className="ml-2">
                        I agree to the{" "}
                        <span
                          className="link-privacy-term-text"
                          onClick={handleOpenTerms}
                        >
                          Terms of Service
                        </span>{" "}
                        and{" "}
                        <span
                          className="link-privacy-term-text"
                          onClick={handleOpenPrivacy}
                        >
                          Privacy Policy
                        </span>
                      </span>
                    </div>

                    
                    <button  type="submit" className="login-form-label-button drop-shadow">Sign up</button>
                  </form>
                  :<form onSubmit={handleLogin} className="login-form">
                    <h2 className="">Get Started</h2>
                    <div className="login-sub-title">
                      <p>Welcome to Stock Archives - Please Sign In</p>
                    </div>

                    <label className="login-form-label" for="femail">Email</label><br/>
                    <input onChange={(e) => setEmail(e.target.value)} type="email" className="login-form-input" required /><br/>
                    <label className="login-form-label" for="fpassword">Password</label><br/>
                    <input onChange={passwordChange}  type="password" className="login-form-input"required />
                    {error == ""?<label></label>:<label className="error">{error}</label>} 
                    <br/>
                    <button  type="submit" className="login-form-label-button drop-shadow">Login</button>
                  </form>
                }

              {
              fromSignup2?null:<div className="already-have-account-text-login-page">
                  <p>Already have an account? <span className="sign-in-text-login-page">Sign In</span></p>
              </div>}
                {fromSignup2?null:<div class="divider">
                  <span>Forgot Password</span>
            </div>}
                {/*fromSignup2?null:<div className="oauth-bottom-container">
                  <div className="oauth-button-container">
                    <button onClick={handleGoogleLogin} className="oauth-button"><FcGoogle className="oauth-logo" size={14} />Sign up with Google</button>
                  </div>
                  <div className="oauth-button-container">
                    <button onClick={handleAppleLoginNone} className="oauth-button"><SiApple className="oauth-logo" />Sign up with Apple</button>
                  </div>
          </div>*/}
                
              </div>

              <div className="login-sidebar">
                <div className="card">
                  <div className="card-top">
                    <div className="card-title">Past</div>
                    <div className="card-subtitle">Performance,</div>
                  </div>
                  <div className="card-bottom">
                    <div className="card-title">Present</div>
                    <div className="card-subtitle">Insight.</div>
                  </div>
                </div>
              </div>
          </div>
        <footer className="footer-section-container-login">
            <FooterSection></FooterSection>
        </footer>
      </div>
        {/* Terms Modal */}
          {termsModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <TermsOfServiceContent/>
            <button onClick={() => setTermsModal(false)}>Close</button>
          </div>
        </div>
      )}

      {/*Privacy Modal */}
      {privacyModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <PrivacyPolicyContent/>
            <button onClick={() => setPrivacyModal(false)}>Close</button>
          </div>
        </div>
      )}
   </div>
  );
};

export default LoginPage;